import Share from '../../src/legacy/Share';
export default Share;
